import AbstractScene from './AbstractScene.js';

// import ButtonZone from '../prefabs/ButtonZone.js';
import RoundedButton from '../prefabs/buttons/RoundedButton.js';
import { Colors } from '../consts/Colors.js';

export default class Fin extends AbstractScene {
    constructor() {
        super({
            key: "Fin"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        
        this._preload();

        this.questionGroup = this.add.group()
    }

    create(){
        // Ajout line
        var line = this.add.sprite(0, 965, 'backLine').setOrigin(0)
        
        var back = this.add.sprite(0, 0, "backFin")
        back.setOrigin(0)

        // var button = new ButtonZone(this, 1340, 285, 730, 140)
        // button.setClickFunction(()=> {
        //     window.open("https://www.mesquestionsdentrepreneur.fr/",'_blank');
        // })
        // var buttonFin = new RoundedButton(this, this.width/2, 870, 360, 80, "Aller sur le site", Colors.Text.Purple, Colors.Elmt.Purple)
        var buttonFin = new RoundedButton(this, this.width/2, 870, { 
            width: 360, 
            height: 80, 
            text: "Aller sur le site", 
            textColor: Colors.Text.White, 
            backgroundColor: Colors.Elmt.Purple, 
            strokeColor: Colors.Elmt.Purple,
            hoverTextColor: Colors.Text.Purple, 
            hoverBackgroundColor: Colors.Elmt.White, 
            fontSize: '32px',
        });
        buttonFin.setClickFunction(()=> {
            window.open("https://www.mesquestionsdentrepreneur.fr/",'_blank');
        })
    }
}